/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteRouteImport } from './routes/_index/route'
import { Route as IndexClientsRouteRouteImport } from './routes/_index/clients/route'
import { Route as IndexReferralsRouteRouteImport } from './routes/_index/referrals/route'
import { Route as ClientsClientExternalIdAcceptRouteRouteImport } from './routes/clients/$clientExternalId/accept/route'

const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/_index',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexClientsRouteRoute = IndexClientsRouteRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => IndexRouteRoute,
} as any)
const IndexReferralsRouteRoute = IndexReferralsRouteRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => IndexRouteRoute,
} as any)
const ClientsClientExternalIdAcceptRouteRoute =
  ClientsClientExternalIdAcceptRouteRouteImport.update({
    id: '/clients/$clientExternalId/accept',
    path: '/clients/$clientExternalId/accept',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRouteWithChildren
  '/clients': typeof IndexClientsRouteRoute
  '/referrals': typeof IndexReferralsRouteRoute
  '/clients/$clientExternalId/accept': typeof ClientsClientExternalIdAcceptRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRouteRouteWithChildren
  '/clients': typeof IndexClientsRouteRoute
  '/referrals': typeof IndexReferralsRouteRoute
  '/clients/$clientExternalId/accept': typeof ClientsClientExternalIdAcceptRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_index': typeof IndexRouteRouteWithChildren
  '/_index/clients': typeof IndexClientsRouteRoute
  '/_index/referrals': typeof IndexReferralsRouteRoute
  '/clients/$clientExternalId/accept': typeof ClientsClientExternalIdAcceptRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/clients' | '/referrals' | '/clients/$clientExternalId/accept'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/clients' | '/referrals' | '/clients/$clientExternalId/accept'
  id:
    | '__root__'
    | '/_index'
    | '/_index/clients'
    | '/_index/referrals'
    | '/clients/$clientExternalId/accept'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRouteWithChildren
  ClientsClientExternalIdAcceptRouteRoute: typeof ClientsClientExternalIdAcceptRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_index': {
      id: '/_index'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_index/clients': {
      id: '/_index/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof IndexClientsRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/referrals': {
      id: '/_index/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof IndexReferralsRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/clients/$clientExternalId/accept': {
      id: '/clients/$clientExternalId/accept'
      path: '/clients/$clientExternalId/accept'
      fullPath: '/clients/$clientExternalId/accept'
      preLoaderRoute: typeof ClientsClientExternalIdAcceptRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface IndexRouteRouteChildren {
  IndexClientsRouteRoute: typeof IndexClientsRouteRoute
  IndexReferralsRouteRoute: typeof IndexReferralsRouteRoute
}

const IndexRouteRouteChildren: IndexRouteRouteChildren = {
  IndexClientsRouteRoute: IndexClientsRouteRoute,
  IndexReferralsRouteRoute: IndexReferralsRouteRoute,
}

const IndexRouteRouteWithChildren = IndexRouteRoute._addFileChildren(
  IndexRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRouteWithChildren,
  ClientsClientExternalIdAcceptRouteRoute:
    ClientsClientExternalIdAcceptRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
